"use client";

import React from "react";
import { Heading, Text } from "@/components/ui/typography";
import Image from "next/image";
import { Divide } from "lucide-react";

const categories = [
  {
    id: 1,
    title: "eCommerce Brands",
    description: "Selling internationally, structured correctly",
  },
  {
    id: 2,
    title: "SaaS Companies",
    description: "Global revenue, optimised tax position",
  },
  {
    id: 3,
    title: "Digital Agencies",
    description: "Serving global clients, paying fair tax",
  },
  {
    id: 4,
    title: "Location-independent, structurally sound",
    description: "Remote Consulting Businesses",
  },
];

export default function Founders({ heading = "Built for Modern Founders" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black  py-[60px]  lg:pb-[120px] px-4 min-[1340px]:px-0">
      <div className="relative max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center justify-between max-sm:gap-16 gap-10">
        {/* IMAGE BLOCK (NOW RESPONSIVE + ALWAYS VISIBLE) */}
        <div className="w-full lg:flex-1 relative h-[250px] sm:h-[380px] md:h-[450px] lg:h-[482px] max-sm:rounded-[16px] rounded-[30px] ">
          <Image
            src="/about/founder.webp"
            alt="Hero Visual"
            fill
            className="object-cover rounded-[30px]"
            priority
          />
        </div>

        {/* CONTENT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          {/* TITLE + TEXT */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <Text variant="muted" className="max-sm:font-normal">
              Today’s online businesses operate globally from the start. Revenue
              comes from multiple countries, payments move across borders, and
              traditional business structures often fail to keep up.
            </Text>
          </div>

          {/* Right Cards */}
          <div className="grid max-sm:grid-cols-1 lg:grid-cols-2 gap-4">
            {categories.map((category) => {
              return (
                <div
                  key={category.id}
                  className="bg-[#0f1218] border border-white/10 max-sm:w-full max-sm:h-auto p-6 w-[284px] h-[118px] rounded-xl"
                >
                  <div className="flex flex-col gap-2">
                    <Text as="h4" className="font-medium leading-[110%]">
                      {category.title}
                    </Text>
                    <Text variant="muted" size="sm" className="leading-[160%]">
                      {category.description}
                    </Text>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
